// Don't use this for semantic versions that have words in it (alpha, beta, rc)
// versionA < versionB ==> -1
// versionA == versionB ==> 0
// versionA > versionB ==> 1

exports.compare = (versionA, versionB) => versionA.localeCompare(
  versionB,
  undefined,
  { numeric: true, sensitivity: 'base' },
);
